import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";

export function SilentNightBanner() {
  return (
    <Reveal className="silent-night-banner" data-testid="silent-night-banner">
      <Link to="/wasteland-radio" aria-label="Tune in to Wasteland Radio" data-testid="wasteland-radio-banner-link">
        <img loading="lazy"
          src="/assets/wasteland-radio-banner.png"
          alt="Wasteland Radio banner — skull with headphones and broadcast tower, show times 24 hours a day"
          data-testid="silent-night-banner-image"
        />
      </Link>
    </Reveal>
  );
}
